import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Space } from 'antd';
import MasterImageService from 'services/master/image';
import MasterImagesModal from './MasterImagesModal';

const imageService = new MasterImageService();

const MasterMultiImagePicker = ({ value = [], onChange, maxPhotos = 10 }) => {
  const [images, setImages] = useState([]);
  const [openLibrary, setOpenLibrary] = useState(false);
  const [uploading, setUploading] = useState(false);
  const uploadInputRef = useRef(null);

  useEffect(() => {
    setImages(Array.isArray(value) ? value : []);
  }, [value]);

  const canUpload = useMemo(() => images.length < maxPhotos, [images, maxPhotos]);

  const commit = (next) => {
    setImages(next);
    onChange?.(next);
  };

  const removeOne = (id) => {
    const next = images.filter((item) => item.id !== id);
    commit(next);
  };

  const onUploadFiles = async (event) => {
    const files = Array.from(event?.target?.files || []);
    if (!files.length) return;

    setUploading(true);
    try {
      const added = [];
      const room = Math.max(0, maxPhotos - images.length);
      const picked = files.slice(0, room);

      for (let i = 0; i < picked.length; i++) {
        const formData = new FormData();
        formData.append('file', picked[i]);
        formData.append('folder', 'root');
        const saved = await imageService.upload(formData);
        added.push(saved);
      }

      commit([...images, ...added]);
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <div>
      <Space wrap>
        {images.map((img) => (
          <div key={img.id || img.url} style={{ border: '1px solid #f0f0f0', borderRadius: 8, padding: 6 }}>
            <img src={img.sm_url || img.url} alt='' style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6 }} />
            <div style={{ marginTop: 6, textAlign: 'center' }}>
              <Button size='small' danger onClick={() => removeOne(img.id)}>Xóa</Button>
            </div>
          </div>
        ))}

        {canUpload && (
          <>
            <Button loading={uploading} onClick={() => uploadInputRef.current?.click()}>Upload</Button>
            <input ref={uploadInputRef} type='file' accept='image/*' multiple style={{ display: 'none' }} onChange={onUploadFiles} />
          </>
        )}

        {canUpload && (
          <Button onClick={() => setOpenLibrary(true)}>Chọn từ thư viện</Button>
        )}
      </Space>

      <MasterImagesModal
        open={openLibrary}
        onCancel={() => setOpenLibrary(false)}
        onSelect={(selected) => {
          const room = Math.max(0, maxPhotos - images.length);
          const append = (selected || []).slice(0, room);
          commit([...images, ...append]);
        }}
      />
    </div>
  );
};

export default MasterMultiImagePicker;
